import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../../core/services';
import {Helper} from '../helper/helper';
import {Store} from '@ngxs/store';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    $currentUser= inject(Store).select(state => state.currentUser);

    constructor(private router: Router, private authService: AuthService, private helper: Helper) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Token-Validierung hinzufügen
        const storedData = localStorage.getItem('currentUser');
        if (storedData) {
            try {
                const parsed = JSON.parse(storedData);
                // Token abgelaufen?
                if (parsed.timestamp && parsed.timestamp + 3600000 < Date.now()) {
                    // Cleanup und Redirect
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('currentUserData');
                    this.router.navigate(['/login'], {
                        queryParams: { returnUrl: state.url },
                    });
                    return false;
                }
            } catch {
                // Fehlerhafte Daten - cleanup
                localStorage.removeItem('currentUser');
                localStorage.removeItem('currentUserData');
            }
        }

        const user = this.authService.userValue;
        if (user) {
            const requiredRoles: [] = route.data.roles;

            if (!requiredRoles || requiredRoles.length === 0) {
                return true;
            } else {
                let granted = false;
                for (const requiredRole of requiredRoles) {
                    if (this.helper.hasRole(requiredRole)) {
                        granted = true;
                        break;
                    }
                }
                if (granted) {
                    return true;
                } else {
                    this.router.navigate(['login']);
                    // return false;
                }
            }
        }
        this.router.navigate(['/login'], {
            queryParams: { returnUrl: state.url },
        });
        return false;
    }
}
